import Router from 'vue-router';
import Ansokan from '@/views/Ansokan.vue';
import Kvittens from '@/views/Kvittens.vue';
import { ETechnicalError } from '@exp/vue';

export default new Router({
    routes: [
        {
            path: '/',
            name: 'Ansökan',
            component: Ansokan,
        },
        {
            path: '/kvittens',
            name: 'Kvittens',
            props: true,
            component: Kvittens,
            meta: {
                reload: true,
            },
        },
        {
            path: '/teknisktfel',
            name: 'teknisktfel',
            props: true,
            component: ETechnicalError,
        },
    ],
});
